export default __webpack_public_path__ + "static/media/hero-img.31a20a35.png";